<mat-card aria-label="Tabs card" class="h-full">
  <mat-tab-group
    aria-label="Tabs group"
    class="h-full"
    (selectedTabChange)="onTabChange($event)"
  >
    <mat-tab
      *ngFor="let tab of tabs; let i = index"
      [disabled]="tab.disabled === true"
      aria-label="Tab {{ tab.title }}"
      [label]="tab.title"
    >
      <ng-template #tabContent></ng-template>
    </mat-tab>
  </mat-tab-group>
</mat-card>
